import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getTicketNotes } from '../../../services/tickets';
import { ITicketNote } from '../../../services/tickets/types';

interface IProps {
  ticketId: string | number;
}
export const ThunkGetTicketNotes = createAsyncThunk<ITicketNote[], IProps>(
  `${storeResources.TICKETS}/getTicketNotes`,
  ({ ticketId }) => getTicketNotes(ticketId).then(res => res.data),
);
